export const tarotCards = [
  // Major Arcana
  { id: 0, name: "The Fool", suit: "major", arcana: "major" },
  { id: 1, name: "The Magician", suit: "major", arcana: "major" },
  { id: 2, name: "The High Priestess", suit: "major", arcana: "major" },
  { id: 3, name: "The Empress", suit: "major", arcana: "major" },
  { id: 4, name: "The Emperor", suit: "major", arcana: "major" },
  { id: 5, name: "The Hierophant", suit: "major", arcana: "major" },
  { id: 6, name: "The Lovers", suit: "major", arcana: "major" },
  { id: 7, name: "The Chariot", suit: "major", arcana: "major" },
  { id: 8, name: "Strength", suit: "major", arcana: "major" },
  { id: 9, name: "The Hermit", suit: "major", arcana: "major" },
  { id: 10, name: "Wheel of Fortune", suit: "major", arcana: "major" },
  { id: 11, name: "Justice", suit: "major", arcana: "major" },
  { id: 12, name: "The Hanged Man", suit: "major", arcana: "major" },
  { id: 13, name: "Death", suit: "major", arcana: "major" },
  { id: 14, name: "Temperance", suit: "major", arcana: "major" },
  { id: 15, name: "The Devil", suit: "major", arcana: "major" },
  { id: 16, name: "The Tower", suit: "major", arcana: "major" },
  { id: 17, name: "The Star", suit: "major", arcana: "major" },
  { id: 18, name: "The Moon", suit: "major", arcana: "major" },
  { id: 19, name: "The Sun", suit: "major", arcana: "major" },
  { id: 20, name: "Judgement", suit: "major", arcana: "major" },
  { id: 21, name: "The World", suit: "major", arcana: "major" },

  // Cups
  { id: 22, name: "Ace of Cups", suit: "cups", arcana: "minor" },
  { id: 23, name: "Two of Cups", suit: "cups", arcana: "minor" },
  { id: 24, name: "Three of Cups", suit: "cups", arcana: "minor" },
  { id: 25, name: "Four of Cups", suit: "cups", arcana: "minor" },
  { id: 26, name: "Five of Cups", suit: "cups", arcana: "minor" },
  { id: 27, name: "Six of Cups", suit: "cups", arcana: "minor" },
  { id: 28, name: "Seven of Cups", suit: "cups", arcana: "minor" },
  { id: 29, name: "Eight of Cups", suit: "cups", arcana: "minor" },
  { id: 30, name: "Nine of Cups", suit: "cups", arcana: "minor" },
  { id: 31, name: "Ten of Cups", suit: "cups", arcana: "minor" },
  { id: 32, name: "Page of Cups", suit: "cups", arcana: "minor" },
  { id: 33, name: "Knight of Cups", suit: "cups", arcana: "minor" },
  { id: 34, name: "Queen of Cups", suit: "cups", arcana: "minor" },
  { id: 35, name: "King of Cups", suit: "cups", arcana: "minor" },

  // Wands
  { id: 36, name: "Ace of Wands", suit: "wands", arcana: "minor" },
  { id: 37, name: "Two of Wands", suit: "wands", arcana: "minor" },
  { id: 38, name: "Three of Wands", suit: "wands", arcana: "minor" },
  { id: 39, name: "Four of Wands", suit: "wands", arcana: "minor" },
  { id: 40, name: "Five of Wands", suit: "wands", arcana: "minor" },
  { id: 41, name: "Six of Wands", suit: "wands", arcana: "minor" },
  { id: 42, name: "Seven of Wands", suit: "wands", arcana: "minor" },
  { id: 43, name: "Eight of Wands", suit: "wands", arcana: "minor" },
  { id: 44, name: "Nine of Wands", suit: "wands", arcana: "minor" },
  { id: 45, name: "Ten of Wands", suit: "wands", arcana: "minor" },
  { id: 46, name: "Page of Wands", suit: "wands", arcana: "minor" },
  { id: 47, name: "Knight of Wands", suit: "wands", arcana: "minor" },
  { id: 48, name: "Queen of Wands", suit: "wands", arcana: "minor" },
  { id: 49, name: "King of Wands", suit: "wands", arcana: "minor" },

  // Swords
  { id: 50, name: "Ace of Swords", suit: "swords", arcana: "minor" },
  { id: 51, name: "Two of Swords", suit: "swords", arcana: "minor" },
  { id: 52, name: "Three of Swords", suit: "swords", arcana: "minor" },
  { id: 53, name: "Four of Swords", suit: "swords", arcana: "minor" },
  { id: 54, name: "Five of Swords", suit: "swords", arcana: "minor" },
  { id: 55, name: "Six of Swords", suit: "swords", arcana: "minor" },
  { id: 56, name: "Seven of Swords", suit: "swords", arcana: "minor" },
  { id: 57, name: "Eight of Swords", suit: "swords", arcana: "minor" },
  { id: 58, name: "Nine of Swords", suit: "swords", arcana: "minor" },
  { id: 59, name: "Ten of Swords", suit: "swords", arcana: "minor" },
  { id: 60, name: "Page of Swords", suit: "swords", arcana: "minor" },
  { id: 61, name: "Knight of Swords", suit: "swords", arcana: "minor" },
  { id: 62, name: "Queen of Swords", suit: "swords", arcana: "minor" },
  { id: 63, name: "King of Swords", suit: "swords", arcana: "minor" },

  // Pentacles
  { id: 64, name: "Ace of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 65, name: "Two of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 66, name: "Three of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 67, name: "Four of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 68, name: "Five of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 69, name: "Six of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 70, name: "Seven of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 71, name: "Eight of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 72, name: "Nine of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 73, name: "Ten of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 74, name: "Page of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 75, name: "Knight of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 76, name: "Queen of Pentacles", suit: "pentacles", arcana: "minor" },
  { id: 77, name: "King of Pentacles", suit: "pentacles", arcana: "minor" },
];

export const getSuitColor = (suit) => {
  const colors = {
    major: 'text-mystical-400',
    cups: 'text-blue-400',
    wands: 'text-red-400',
    swords: 'text-gray-400',
    pentacles: 'text-green-400',
  };
  return colors[suit] || 'text-gray-400';
};

export const getSuitIcon = (suit) => {
  const icons = {
    major: '✨',
    cups: '🏆',
    wands: '🔥',
    swords: '⚔️',
    pentacles: '💰',
  };
  return icons[suit] || '🃏';
};